const SvgInstagram = () => (
	<svg width="1em" height="1em" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			strokeWidth={2}
			d="M21.833 6.313c0 1.187-1.565 2.072-2.777.465-.695-.921-.448-3.71 2.777-3.653 3.226.057 4.122 2.763 4.167 4.11v10.91c0 6.574-4.48 8.643-6.72 8.855H8.392C2.586 27 1.045 22.324 1 19.986V9.218C1 2.814 5.122 1.071 7.183 1h9.812C13.79 2.488 6.986 5.43 7.183 12.618c.201 7.368 6.883 9.275 9.812 6.235 2.928-3.04 1.366-9.635-3.495-9.635"
		/>
	</svg>
)

export default SvgInstagram
